import { useContext } from "react";
import { ExperienceContext } from "@/App/context";
import { MemberEligibilityInfo } from "@/App/types";
import { getCustomerSupportNumber } from "@/App/utils/utils";
import "./MemberCard.scss";
import { ScreenReader } from "../../ScreenReader";

interface Props {
  memberEligibilityInfo: MemberEligibilityInfo;
}

export const NonDiscountCardBack: React.FC<Props> = (props: Props) => {
  const { memberEligibilityInfo } = props;
  const { memberCardCustomerSupportHours, customerSupportPhoneNumber } = useContext(ExperienceContext);

  const customerSupportNumber = getCustomerSupportNumber(memberEligibilityInfo, customerSupportPhoneNumber);

  return (
    <div className="cv2">
      <div className={`member-id-card-container member-id-card-back`}>
        <div role="presentation" className="member-id-card-header">
          <div className="member-id-card-header-text">
            <div className="member-id-card-header-title">
              <p className="member-id-card-header-title-phone">Customer Care: {customerSupportNumber}</p>
              <p>{memberCardCustomerSupportHours ?? "Support is available 24 hours a day, 7 days a week"}</p>
            </div>
          </div>
        </div>
        <div className="member-id-card-info">
          <div className="member-id-card-info-container">
            <div>
              <p className="member-id-card-info-container-title">Members</p>
              <p>
                Present this card at a participating pharmacy when filling your prescriptions. This card does not guarantee coverage and is
                subject to your benefits at the time of service.
              </p>
              <p className="member-id-card-info-container-title">Pharmacists</p>
              <ul>
                <li>Enter Cardholder&apos;s Member ID.</li>
                <li>Enter Member&apos;s date of birth.</li>
                <li>Enter Relationship Code: 1(Cardholder), 2(Spouse), 3(Child), 4(Other).</li>
                <li>Contact Customer Care for processing support.</li>
              </ul>
            </div>
            <div>
              <p>Scan here to experience your pharmacy benefits on our mobile application.</p>
              <div role="img" className="member-id-card-info-container-qr">
                <ScreenReader>Download App QR Code</ScreenReader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
